import React from 'react';
import Icon from '../atoms/Icon';

function RunnerIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 32 27">
      <g
        fill='none'
        fillRule='nonzero'
      >
        <path d="M27.7708 6.45832C29.1976 6.45832 30.3542 5.30173 30.3542 3.87499C30.3542 2.44825 29.1976 1.29166 27.7708 1.29166C26.3441 1.29166 25.1875 2.44825 25.1875 3.87499C25.1875 5.30173 26.3441 6.45832 27.7708 6.45832Z" stroke="currentColor" stroke-width="2.58333" stroke-miterlimit="10"/>
        <path d="M11.3589 3.47844L16.2621 2.08731C16.6005 1.99173 16.9648 2.03823 17.2683 2.21519L21.1058 4.46527C21.2725 4.56344 21.4145 4.69648 21.523 4.85665L24.3221 8.99773C24.4642 9.21215 24.5417 9.46402 24.5417 9.72106V12.2708C24.5417 12.9838 25.1203 13.5625 25.8333 13.5625H31" stroke="currentColor" stroke-width="2.58333" stroke-miterlimit="10"/>
        <path d="M21.2634 4.67712L15.1745 9.81537C14.3336 10.5258 14.0094 11.6767 14.3582 12.7203L16.2259 18.321C16.5036 19.1567 15.881 20.0208 15.0001 20.0208H9.04166" stroke="currentColor" stroke-width="2.58333" stroke-miterlimit="10"/>
      </g>

      <g
        fill='currentColor'
        fillRule='nonzero'
      >
        <path d="M20.2469 20.2663L17.5408 26.4792H20.3592L22.6158 21.2983C22.9322 20.5711 22.9012 19.7522 22.528 19.0508L19.9898 14.2871L24.1167 10.2429L22.3084 8.39713L18.1828 12.44C17.369 13.2357 17.174 14.4938 17.7087 15.5013L20.2469 20.2663Z"/>
        <path d="M12.4207 7.10416H0V9.68749H10.7299C11.0722 8.72132 11.6418 7.83653 12.4207 7.10416Z"/>
        <path d="M10.6821 13.9461C10.4974 13.3933 10.4044 12.8314 10.3682 12.2708H0V14.8541H10.9843L10.6821 13.9461Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(RunnerIcon);
